import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";

import { SecondaryStyle } from "../fonts";

import Carousel1Image1 from "../assets/Page2R1.webp";
import Carousel1Image2 from "../assets/Page2R2.webp";

import LD from "../assets/Page2LD.webp";
import LB from "../assets/Page2LB.webp";
//@ts-ignore
import LA from "../assets/Page2LA.mp4";

const carousel1Images = [Carousel1Image1, Carousel1Image2];

const Page2 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{ enter: 1750, exit: 1750 }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* 1st Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              {/* Top Section */}
              <Grid
                container
                direction="row"
                sx={{ height: { xs: "92vh", sm: "50vh" } }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    backgroundImage: `url('${LD}')`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderBottom: { xs: "none", sm: "0.5vh solid #fff" },
                    borderLeft: { xs: "1vh solid #fff", sm: "none" },
                    borderTop: { xs: "1vh solid #fff", sm: "none" },
                    borderRadius: { xs: "16px", sm: 0 },
                    borderRight: {
                      xs: "1vh solid #fff",
                      sm: ".5vh solid #fff",
                    },
                    height: { xs: "45.5vh", sm: "50vh" },
                  }}
                />

                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    borderBottom: ".5vh solid #fff",
                    borderRadius: { xs: "16px", sm: 0 },
                    borderLeft: { xs: "1vh solid #fff", sm: ".5vh solid #fff" },
                    borderRight: {
                      xs: "1vh solid #fff",
                      sm: ".5vh solid #fff",
                    },
                    borderTop: { xs: ".5vh solid #fff", sm: "none" },
                    height: { xs: "45.5vh", sm: "50vh" },
                  }}
                >
                  <CardMedia
                    component="video"
                    sx={{
                      borderRadius: { xs: "16px", sm: 0 },
                      height: { xs: "45vh", sm: "49.6vh" },
                      objectFit: "cover",
                    }}
                    src={LA}
                    autoPlay
                    muted
                    loop
                    playsInline
                  />
                </Grid>
              </Grid>

              {/* Bottom Section */}
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction="row"
                  sx={{ height: { xs: "45vh", sm: "50vh" } }}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderRadius: { xs: "16px", sm: 0 },

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderTop: ".5vh solid #fff",
                      borderLeft: { xs: "1vh solid #fff", sm: "none" },
                      backgroundImage: `url('${LB}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* 2nd Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={9}>
                <Grid
                  container
                  direction={"row"}
                  sx={{ height: { xs: "35vh", sm: "100%" } }}
                >
                  {/* LD/LA */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: ".1vh solid #fff",
                      },
                      borderTop: { xs: "1vh solid #fff", sm: "none" },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper
                      images={carousel1Images}
                      showArrows={true}
                      showDots={true}
                      autoplay={true}
                    />
                  </Grid>
                </Grid>

                {/* LB Text Section */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    pb: { xs: 1.5 },
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      ...SecondaryStyle,
                      textAlign: "justify",
                      "@media (orientation: landscape)": {
                        fontSize: { xs: "1vw", md: "1vw", lg: "1vw" },
                        lineHeight: { xs: "1.1vw", md: "1.1vw", lg: "1.1vw" },
                        paddingTop: "2vw",
                        px: { xs: "2vh", sm: "2vw" },
                      },
                      "@media (orientation: portrait)": {
                        fontSize: { xs: "1.7vh", sm: "1vh" },
                        lineHeight: {
                          xs: "2vh",
                          sm: "1.65vh",
                          md: "1.5vh",
                          lg: "1.8vh",
                        },
                        paddingTop: {
                          xs: "1vh",
                          sm: "2.2vh",
                          md: "1.2vh",
                          lg: "0vh",
                        },
                        px: { xs: "1.5vh", sm: "2vw" },
                      },
                    }}
                  >
                    This kitchen and breakfast area perfectly blend style and
                    functionality, offering a vibrant and welcoming atmosphere
                    for modern living. Natural light pours in, highlighting the
                    sleek countertops, ceiling-height cabinets, and colourful
                    updates. The high-end stainless steel appliances provide a
                    chef's dream space, while ample cupboard space ensures
                    practicality. The cozy breakfast nook invites casual meals
                    or morning coffee, seamlessly connected to the open-concept
                    layout, making it ideal for entertaining and everyday family
                    life.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page2;
